import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { DeleteWordPairDicArgs } from 'src/app/core/commands/delete-word-pair-dic/delete-word-pair-dic.command'
import { EditWordPairDicArgs } from 'src/app/core/commands/edit-word-pair-dic/edit-word-pair-dic.command'
import { Backend } from 'src/app/shared/enums/enums'
import { CreateWordPairDicArgs } from '../../core/commands/create-word-pair-dic/create-word-pair-dic.command'

export interface WordPairDicResponse {
  success: boolean
  message: string
  data?: any // Adjust type as needed based on the response structure
}
@Injectable({
  providedIn: 'root',
})
export class WordPairDicService {
  constructor(private http: HttpClient) {}

  create(args: CreateWordPairDicArgs): Observable<WordPairDicResponse> {
    return this.http.post<WordPairDicResponse>(
      `${Backend.HOST_CONTAINER + Backend.WORD_PAIR_DIC}`,
      args,
    )
  }

  edit(args: EditWordPairDicArgs): Observable<WordPairDicResponse> {
    return this.http.patch<WordPairDicResponse>(
      `${Backend.HOST_CONTAINER + Backend.WORD_PAIR_DIC + args.id}/`,
      args,
    )
  }

  delete(args: DeleteWordPairDicArgs): Observable<WordPairDicResponse> {
    return this.http.post<WordPairDicResponse>(
      `${Backend.HOST_CONTAINER + Backend.WORD_PAIR_DIC}`,
      args,
    )
  }
}
